<div class="container">
    <h1 class="mt120">{{bookdetails.bookHeading}}</h1>
    <hr class="mb-0" />
</div>

<div class="mainContnet">
    <div class="container">
        <p>{{bookdetails.bookDescription}}</p>
        
        <div class="row mt-5">
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="mx-auto d-table">
                    <figure class="book">
                        <img [src]="bookdetails.bookImageURl" class="img-fluid" width="185" height="279" />
                        <figcaption>Учебное пособие</figcaption>
                    </figure>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="btnCenter">
                    <h2 class="text-center">Учебное пособие</h2>
                    <a *ngIf="bookdetails.isSampleDOC" href="{{bookdetails.sampleDOCLink}}" class="btn btnSecondary mt-2">Скачать DOC</a>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="mx-auto d-table">
                    <h2 class="text-center">Руководство Лидеры</h2>
                    <a *ngIf="bookdetails.isLeaderGuideSmapleDOC" href="{{bookdetails.leaderSampleDOClink}}" class="btn btnSecondary mt-2">Скачать DOC</a>
                    <p *ngIf="bookdetails.isLeaderGuidButton" class="has-text-align-center">Руководство для лидера не доступен . Если вы готовитесь руководство хорошо написанном лидера , мы можем сделать его доступным здесь , на благо других. &nbsp;<a href="mailto:admin@TrainingInMinistry.com?Subject=Leaders%20Guide">Свяжитесь с нами</a> Чтобы получить больше информации.</p>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <p class="note"><strong>заметка: </strong>{{bookdetails.note}}</p>
        </div>

    </div>
    <app-static-footer></app-static-footer>
</div>
